export const SETTINGS_KEY = 'appSettings';

export const defaultAppSettings = {
  defaultLandingPage: 'dashboard',
  dateFormat: 'en-IN',
  compactTables: false,
  showNotifications: true
};

export const getAppSettings = () => {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return defaultAppSettings;
    const parsed = JSON.parse(raw);
    return { ...defaultAppSettings, ...parsed };
  } catch {
    return defaultAppSettings;
  }
};

export const saveAppSettings = (settings) => {
  const finalSettings = { ...defaultAppSettings, ...settings };
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(finalSettings));
  return finalSettings;
};

export const getLandingPath = (defaultLandingPage) => {
  switch (defaultLandingPage) {
    case 'projects':
      return '/projects';
    case 'help':
      return '/help';
    case 'dashboard':
    default:
      return '/dashboard';
  }
};
